export * from './header/header.component';
export * from './home/home.component';
export * from './terms-and-conditions/terms-and-conditions.component';
export * from './document-attachment/document-attachment.component';
export * from './declarations/declarations.component';
export * from './test/test.component';
export * from './otp/otp.component';
export * from './landing/landing.component';
export * from './breadcrumb/breadcrumb.component';
export * from './camera-dialog/camera-dialog.component';